import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MarketSectorService, PropositionService } from '@arkius/shared-api';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'ark-lib-proposition-slider',
  templateUrl: './proposition-slider.component.html',
  styleUrls: ['./proposition-slider.component.css'],
})
export class PropositionSliderComponent implements OnInit {
  @Input() propositions: any[] = [];

  @Output() subscribed = new EventEmitter<number>();
  @Output() unsubscribed = new EventEmitter<number>();

  size = 6;
  pageSize = 6;
  filteredPropositions: any[] = [];

  constructor() {}
  ngOnInit(): void {
    this.filteredPropositions = this.propositions.slice(0, this.pageSize);
  }

  subscriptionChange(proposition: any, subscribed: boolean) {
    proposition.isSubscribed = subscribed;
    if (subscribed) this.subscribed.emit(proposition.propositionId);
    if (!subscribed) this.unsubscribed.emit(proposition.propositionId);
  }

  onViewMore() {
    const nextSlice = this.propositions.slice(
      this.pageSize,
      this.pageSize + this.size,
    );
    this.filteredPropositions = [...this.filteredPropositions, ...nextSlice];
    this.pageSize += this.size;
  }
}
